import { render, staticRenderFns } from "./PeppolContactRegistrationStatus.vue?vue&type=template&id=0817c44c&scoped=true"
import script from "./PeppolContactRegistrationStatus.vue?vue&type=script&lang=ts"
export * from "./PeppolContactRegistrationStatus.vue?vue&type=script&lang=ts"
import style0 from "./PeppolContactRegistrationStatus.vue?vue&type=style&index=0&id=0817c44c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0817c44c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0817c44c')) {
      api.createRecord('0817c44c', component.options)
    } else {
      api.reload('0817c44c', component.options)
    }
    module.hot.accept("./PeppolContactRegistrationStatus.vue?vue&type=template&id=0817c44c&scoped=true", function () {
      api.rerender('0817c44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/peppol/PeppolContactRegistrationStatus.vue"
export default component.exports